import _get from 'lodash/get'
import {
  createOrder,
  createCheckoutOrder,
  getPaypalToken,
  captureEmail,
  CHECKOUT_ORDER_ERROR_TYPE_UNKNOWN,
} from './index'
import './types'

export const SET_CHECKOUT_ACCOUNT_VALID = 'SET_CHECKOUT_ACCOUNT_VALID'
export const SET_CHECKOUT_ACCOUNT_CREATE_DATA = 'SET_CHECKOUT_ACCOUNT_CREATE_DATA'
export const SET_CHECKOUT_USER_DATA = 'SET_CHECKOUT_USER_DATA'
export const SET_CHECKOUT_ORDER_PROCESSING = 'SET_CHECKOUT_ORDER_PROCESSING'
export const SET_CHECKOUT_ORDER_DATA = 'SET_CHECKOUT_ORDER_DATA'
export const SET_CHECKOUT_ORDER_COMPLETE = 'SET_CHECKOUT_ORDER_COMPLETE'
export const SET_CHECKOUT_ORDER_ERROR = 'SET_CHECKOUT_ORDER_ERROR'
export const SET_CHECKOUT_PAYPAL_TOKEN = 'SET_CHECKOUT_PAYPAL_TOKEN'
export const SET_CHECKOUT_PAYPAL_PAYMENT = 'SET_CHECKOUT_PAYPAL_PAYMENT'
export const SET_CHECKOUT_EMAIL_CAPTURE_STATUS = 'SET_CHECKOUT_EMAIL_CAPTURE_STATUS'
export const RESET_CHECKOUT_EMAIL_CAPTURE_STATUS = 'RESET_CHECKOUT_EMAIL_CAPTURE_STATUS'
export const SET_CHECKOUT_PAYPAL_TOKEN_PROCESSING = 'SET_CHECKOUT_PAYPAL_TOKEN_PROCESSING'
export const SET_CHECKOUT_PAYPAL_NONCE = 'SET_CHECKOUT_PAYPAL_NONCE'
export const SET_CHECKOUT_BRAIN_TREE_PROCESSING = 'SET_CHECKOUT_BRAIN_TREE_PROCESSING'
export const SET_CHECKOUT_BRAIN_TREE_READY = 'SET_CHECKOUT_BRAIN_TREE_READY'
export const SET_CHECKOUT_STEP = 'SET_CHECKOUT_STEP'
export const SET_CHECKOUT_EVENT_STEP = 'SET_CHECKOUT_EVENT_STEP'
export const RESET_CHECKOUT = 'RESET_CHECKOUT'
export const SET_CHECKOUT_PLAN_SELECTION = 'SET_CHECKOUT_PLAN_SELECTION'
export const RESET_PAYPAL = 'RESET_PAYPAL'
export const SELECT_PAYMENT_TYPE = 'SELECT_PAYMENT_TYPE'
export const SET_CHECKOUT_REACTIVATION = 'SET_CHECKOUT_REACTIVATION'
export const SET_CHECKOUT_ORDER_REFERENCE = 'SET_CHECKOUT_ORDER_REFERENCE'

export function processCheckoutOrder (options) {
  const {
    token, userInfo, paymentInfo, tracking, language,
  } = options
  return async function processCheckoutOrderThunk (dispatch) {
    //
    dispatch(setCheckoutOrderProcessing(true))

    try {
      const order = await createOrder({
        token,
        userInfo: userInfo.toJS(),
        paymentInfo,
        tracking,
        language,
      })
      const orderErrorCode = _get(order, 'errorCode')
        ? _get(order, 'errorCode')
        : CHECKOUT_ORDER_ERROR_TYPE_UNKNOWN

      if (!_get(order, 'success')) {
        dispatch(setCheckoutOrderError(orderErrorCode))
        return
      }
      dispatch(setCheckoutOrderData(order))
    } catch (e) {
      dispatch(setCheckoutOrderError(
        CHECKOUT_ORDER_ERROR_TYPE_UNKNOWN,
      ))
      throw e
    }
  }
}

export function processCheckoutOrderV2 (options) {
  const {
    paymentInfo,
    tracking,
    auth,
    startDateOverrideInfo,
    reactivation,
    emailOptIn,
    fbEventId,
  } = options
  return async function processCheckoutOrderV2Thunk (dispatch) {
    dispatch(setCheckoutOrderProcessing(true))
    try {
      const order = await createCheckoutOrder({
        paymentInfo,
        tracking,
        auth,
        startDateOverrideInfo,
        reactivation,
        emailOptIn,
        fbEventId,
      })
      const orderErrorCode = _get(order, 'errorCode') ? _get(order, 'errorCode') : CHECKOUT_ORDER_ERROR_TYPE_UNKNOWN
      if (_get(order, 'success')) {
        dispatch(setCheckoutOrderData({ ...order, isReactivation: reactivation }))
      } else {
        dispatch(setCheckoutOrderError(orderErrorCode))
      }
    } catch (e) {
      dispatch(setCheckoutOrderError(CHECKOUT_ORDER_ERROR_TYPE_UNKNOWN))
      throw e
    }
  }
}

export function captureCheckoutEmail (options) {
  return async function captureCheckoutEmailThunk (dispatch) {
    try {
      const res = await captureEmail(options)
      const { success, errorCode } = res
      dispatch(setCheckoutEmailCaptureStatus(success, errorCode))
    } catch (e) {
      dispatch(setCheckoutEmailCaptureStatus(false, null))
    }
  }
}

export function getCheckoutPayPalCredentials () {
  return async function getCheckoutPayPalCredentialsThunk (dispatch) {
    try {
      dispatch(setCheckoutPaypalTokenProcessing(true))
      const res = await getPaypalToken()
      dispatch(setCheckoutPaypalToken(res.token))
    } catch (e) {
      dispatch(setCheckoutPaypalTokenProcessing(false))
    }
  }
}

export function setCheckoutAccountValid (value) {
  return {
    type: SET_CHECKOUT_ACCOUNT_VALID,
    payload: value,
  }
}

export function setCheckoutOrderError (data) {
  return {
    type: SET_CHECKOUT_ORDER_ERROR,
    payload: data,
  }
}

export function setCheckoutAccountCreateData (data) {
  return {
    type: SET_CHECKOUT_ACCOUNT_CREATE_DATA,
    payload: data,
  }
}

export function setCheckoutUserData (data) {
  return {
    type: SET_CHECKOUT_USER_DATA,
    payload: data,
  }
}

export function setCheckoutOrderData (data) {
  return {
    type: SET_CHECKOUT_ORDER_DATA,
    payload: data,
  }
}

export function setCheckoutOrderProcessing (data) {
  return {
    type: SET_CHECKOUT_ORDER_PROCESSING,
    payload: data,
  }
}

export function setCheckoutOrderComplete (data) {
  return {
    type: SET_CHECKOUT_ORDER_COMPLETE,
    payload: data,
  }
}

export function setCheckoutPaypalTokenProcessing (value) {
  return {
    type: SET_CHECKOUT_PAYPAL_TOKEN_PROCESSING,
    payload: value,
  }
}

export function setCheckoutPaypalToken (data) {
  return {
    type: SET_CHECKOUT_PAYPAL_TOKEN,
    payload: data,
  }
}

export function setCheckoutPaypalPayment () {
  return {
    type: SET_CHECKOUT_PAYPAL_PAYMENT,
  }
}

export function setCheckoutPayPalNonce (data) {
  return {
    type: SET_CHECKOUT_PAYPAL_NONCE,
    payload: data,
  }
}

export function setCheckoutBrainTreeProcessing (value) {
  return {
    type: SET_CHECKOUT_BRAIN_TREE_PROCESSING,
    payload: value,
  }
}

export function setCheckoutBrainTreeReady (ready, processing = false) {
  return {
    type: SET_CHECKOUT_BRAIN_TREE_READY,
    payload: { ready, processing },
  }
}

export function setCheckoutEmailCaptureStatus (status, errorCode) {
  return {
    type: SET_CHECKOUT_EMAIL_CAPTURE_STATUS,
    payload: { status, errorCode },
  }
}

export function resetCheckoutEmailCaptureStatus () {
  return {
    type: RESET_CHECKOUT_EMAIL_CAPTURE_STATUS,
  }
}

export function setCheckoutStep (value) {
  return {
    type: SET_CHECKOUT_STEP,
    payload: value,
  }
}

export function setCheckoutEventStep (value) {
  return {
    type: SET_CHECKOUT_EVENT_STEP,
    payload: value,
  }
}

export function resetCheckout () {
  return {
    type: RESET_CHECKOUT,
  }
}

export function setPlanSelection (payload) {
  return {
    type: SET_CHECKOUT_PLAN_SELECTION,
    payload,
  }
}

export function resetPaypal () {
  return {
    type: RESET_PAYPAL,
  }
}

/**
 * @typedef {Object} PaymentTypeSelectedAction
 * @property {String} PaymentTypeSelectedAction.type
 * @property {PaymentType} PaymentTypeSelectedAction.payload
 *
 * @param {PaymentType} payementType
 * @returns {PaymentTypeSelectedAction} action
 */
export function paymentTypeSelected (payload) {
  return {
    type: SELECT_PAYMENT_TYPE,
    payload,
  }
}

export function setCheckoutReactivation (value) {
  return {
    type: SET_CHECKOUT_REACTIVATION,
    payload: value,
  }
}

export function setCheckoutOrderReference (value) {
  return {
    type: SET_CHECKOUT_ORDER_REFERENCE,
    payload: value,
  }
}
